export enum Theme {
  Webshop,
  Equinem,
  // PaReg, <-- We can add this later.
}
